// extracted by mini-css-extract-plugin
var _1 = "Overlay-mJutP";
var _2 = "fadeOverlay-LBaPB";
export { _1 as "Overlay", _2 as "fadeOverlay" }
